import { Controller } from '@hotwired/stimulus';

// 管理者の給与明細送信統計の月次推移グラフ (#3118)。
// Chart.js は画面の <head> で CDN から同期読み込みしている (admin/payrolls/index)。
// 同期スクリプトなので connect() の時点では読み込み済みだが、読み込みに失敗した
// ときにページ全体を壊さないようガードする。
const SERIES = [
  { key: 'payroll_count', label: '給与明細数', color: 'rgb(153, 102, 255)', fill: 'rgba(153, 102, 255, 0.2)' },
  { key: 'user_payroll_count', label: '個人明細数', color: 'rgb(255, 159, 64)', fill: 'rgba(255, 159, 64, 0.2)' },
  { key: 'sent_count', label: '送信数', color: 'rgb(75, 192, 192)', fill: 'rgba(75, 192, 192, 0.2)' },
  { key: 'sent_with_pdf_count', label: 'PDF送信数', color: 'rgb(255, 99, 132)', fill: 'rgba(255, 99, 132, 0.2)' },
  { key: 'line_sent_count', label: 'LINE送信数', color: 'rgb(54, 162, 235)', fill: 'rgba(54, 162, 235, 0.2)' },
];

export default class extends Controller {
  static values = { stats: Array };

  connect() {
    if (typeof window.Chart !== 'function') return;

    const rows = this.statsValue || [];
    this.chart = new window.Chart(this.element.getContext('2d'), {
      type: 'line',
      data: {
        labels: rows.map((d) => d.month),
        datasets: SERIES.map((s) => ({
          label: s.label,
          data: rows.map((d) => d[s.key]),
          borderColor: s.color,
          backgroundColor: s.fill,
          tension: 0.1,
        })),
      },
      options: {
        responsive: true,
        plugins: {
          legend: { position: 'top' },
          title: { display: true, text: '月次給与明細送信推移' },
        },
        scales: { y: { beginAtZero: true } },
      },
    });
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
